import request from '@/utils/request'
import {cmsServerContext} from '@/config/config'

/**
 * 能耗单元树
 * @param customerId
 * @param approachId
 * @param type
 * @param meterUnitType
 */
export function selectEnergyUnit(customerId, approachId, type, meterUnitType, enabled) {
  return request({
    url: cmsServerContext + '/EnergyUnit/selectEnergyUnit',
    method: 'post',
    data: {
      'customerId': customerId,
      'approachId': approachId,
      'type': type,
      'meterUnitType': meterUnitType,
      'enabled': enabled
    }
  })
}

export function selectEnergyUnitById(id) {
  return request({
    url: cmsServerContext + '/EnergyUnit/selectEnergyUnitById/' + id,
    method: 'get'
  })
}

export function insertEnergyUnit(energyUnit) {
  return request({
    url: cmsServerContext + '/EnergyUnit/insertEnergyUnit',
    method: 'post',
    data: energyUnit
  })
}

export function insertCustomerUserEnergyUnit(energyUnit) {
  return request({
    url: cmsServerContext + '/EnergyUnit/insertCustomerUserEnergyUnit',
    method: 'post',
    data: energyUnit
  })
}

export function selectCustomerUser(id, customerId) {
  return request({
    url: cmsServerContext + '/EnergyUnit/selectCustomerUser/' + customerId + '/' + id,
    method: 'get'
  })
}

export function selectCustomerUserByUid(id) {
  return request({
    url: cmsServerContext + '/EnergyUnit/selectCustomerUserByUid/' + id,
    method: 'get'
  })
}

export function energyUnitEnergyData(energyDataQueryParam) {
  return request({
    url: cmsServerContext + '/energyUnitEnergyData/energyUnitEnergy',
    method: 'post',
    data: energyDataQueryParam
  })
}

export function EnergyUnitEnergyDay(energyDataQueryParam) {
  return request({
    url: cmsServerContext + '/EnergyUnitEnergyDay/energyUnitEnergy',
    method: 'post',
    data: energyDataQueryParam
  })
}

export function deleteCustomerEnergyUtil(map) {
  return request({
    url: cmsServerContext + '/EnergyUnit/deleteCustomerEnergyUtil',
    method: 'post',
    data:map
  })
}

export function deleteEnergyUtil(map) {
  return request({
      url: cmsServerContext + '/EnergyUnit/deleteEnergyUtil',
      method: 'post',
    data:map
  })
}

export function saveEnergyUnit(energyUnit) {
  return request({
    url: cmsServerContext + '/EnergyUnit/save',
    method: 'post',
    data:energyUnit
  })
}
